export default __webpack_public_path__ + "static/media/wcag.png.webp";